'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deselectAllElements = exports.toggleSelectedElements = exports.setSelectedElements = exports.addSelectedElements = exports.removeSelectedElements = exports.finishEditingElement = exports.startEditingElementWithDelay = exports.startEditingElement = undefined;

var _lodash = require('lodash');

var _timeUtil = require('../../../common/utils/timeUtil');

var _permissionUtil = require('../../../common/permissions/permissionUtil');

var _permissionsService = require('../../utils/permissions/permissionsService');

var _selectedElementsSelector = require('./selectedElementsSelector');

var _currentlyEditingSelector = require('./currentlyEditingSelector');

var _currentUserSelector = require('../../user/currentUserSelector');

var _elementSelector = require('../elementSelector');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _selectionConstants = require('../../../common/elements/selectionConstants');

var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Util


// Constants


var startEditingElement = exports.startEditingElement = function startEditingElement(_ref) {
    var id = _ref.id,
        editorKey = _ref.editorKey,
        transactionId = _ref.transactionId;
    return function (dispatch, getState) {
        var state = getState();
        var remoteSelectedElements = state.getIn(['remoteActivity', 'selectedElements']);

        if (remoteSelectedElements.getIn([id, 'userId'])) {
            console.warn('Cannot edit as it is remotely active', id);
            return;
        }

        var elements = (0, _elementSelector.getElements)(state);
        var currentUserId = (0, _currentUserSelector.getCurrentUserId)(state);
        var acl = (0, _permissionsService.getUserPermissions)(elements, id, currentUserId);

        if (acl && !(0, _permissionUtil.canWrite)(acl)) return;

        return dispatch({
            type: SELECTION_ACTION_TYPES.ELEMENT_EDIT_START,
            id: id,
            editorKey: editorKey,
            transactionId: transactionId,
            sync: false
        });
    };
};

var startEditingElementWithDelay = exports.startEditingElementWithDelay = function startEditingElementWithDelay(_ref2) {
    var id = _ref2.id,
        editDelay = _ref2.editDelay,
        editorKey = _ref2.editorKey,
        transactionId = _ref2.transactionId;
    return function (dispatch, getState) {
        if ((0, _currentlyEditingSelector.getCurrentlyEditingId)(getState()) === id) return;

        (0, _lodash.delay)(function () {
            var selectedIds = (0, _selectedElementsSelector.getSelectedElementIds)(getState());
            if (!selectedIds.contains(id)) return;

            dispatch(startEditingElement({ id: id, editorKey: editorKey, transactionId: transactionId }));
        }, editDelay);
    };
};

var finishEditingElement = exports.finishEditingElement = function finishEditingElement() {
    return { type: SELECTION_ACTION_TYPES.ELEMENT_EDIT_COMPLETE, sync: false };
};

// ELEMENT SELECTIONS

/**
 * Removes the elements from the list of selected elements.
 */
var removeSelectedElements = exports.removeSelectedElements = function removeSelectedElements(_ref3) {
    var ids = _ref3.ids,
        transactionId = _ref3.transactionId;
    return function (dispatch, getState) {
        if ((0, _lodash.isEmpty)(ids)) return;

        return dispatch({
            type: SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED,
            ids: ids,
            sync: true,
            timestamp: (0, _timeUtil.getTimestamp)(),
            transactionId: transactionId
        });
    };
};

/**
 * Selects the specified elements if they are not already remotely selected.
 */
var addSelectedElements = exports.addSelectedElements = function addSelectedElements(_ref4) {
    var ids = _ref4.ids,
        transactionId = _ref4.transactionId;
    return function (dispatch, getState) {
        var state = getState();
        var remoteSelectedElements = state.getIn(['remoteActivity', 'selectedElements']);
        var elementIdsToSelect = ids.filter(function (id) {
            return !remoteSelectedElements.getIn([id, 'userId']);
        });

        if (!elementIdsToSelect.length) return;

        // Remove currently selected elements whose parents are being selected
        var currentlySelectedElements = (0, _selectedElementsSelector.getSelectedElements)(state);
        var currentlySelectedChildElementIds = currentlySelectedElements.filter(function (element) {
            return element && (0, _lodash.includes)(ids, element.getIn(['location', 'parentId']));
        }).map(function (element) {
            return element.get('id');
        }).toJS();
        dispatch(removeSelectedElements({ ids: currentlySelectedChildElementIds, transactionId: transactionId }));

        // Filter out ids that already have their parents selected (or will have their parents selected by this operation)
        // And filter elements that are already selected
        var elements = (0, _elementSelector.getElements)(state);
        var currentlySelectedIds = (0, _selectedElementsSelector.getSelectedElementIds)(state).toJS();
        var elementsToSelect = (0, _immutableHelper.getMany)(ids, elements);
        var finalSelectedElementIds = [].concat(_toConsumableArray(elementIdsToSelect), _toConsumableArray(currentlySelectedElements.map(function (element) {
            return element.get('id');
        }).toJS()));
        elementIdsToSelect = elementsToSelect.filter(function (element) {
            return element && !(0, _lodash.includes)(finalSelectedElementIds, element.getIn(['location', 'parentId'])) && !(0, _lodash.includes)(currentlySelectedIds, element.get('id'));
        }).map(function (element) {
            return element.get('id');
        }).keySeq().toArray();

        if (!elementIdsToSelect.length) return;

        return dispatch({
            type: SELECTION_ACTION_TYPES.ELEMENTS_SELECTED,
            ids: elementIdsToSelect,
            timestamp: (0, _timeUtil.getTimestamp)(),
            sync: true,
            transactionId: transactionId
        });
    };
};

/**
 * Sets the specified elements as selected and deselects other elements which were selected.
 */
var setSelectedElements = exports.setSelectedElements = function setSelectedElements(_ref5) {
    var ids = _ref5.ids,
        transactionId = _ref5.transactionId;
    return function (dispatch, getState) {
        var state = getState();
        var currentSelection = (0, _selectedElementsSelector.getSelectedElementIds)(state);

        if (currentSelection.size) {
            var currentlySelectedIds = currentSelection.toJS();

            var deselectedIds = (0, _lodash.difference)(currentlySelectedIds, ids);
            dispatch(removeSelectedElements({ ids: deselectedIds, transactionId: transactionId }));

            var newIds = (0, _lodash.difference)(ids, currentlySelectedIds);
            if (!newIds.length) return;
        }

        return dispatch(addSelectedElements({ ids: ids, transactionId: transactionId }));
    };
};

/**
 * Selects elements (in the ids array) who are not already selected and deselect elements who are already selected.
 */
var toggleSelectedElements = exports.toggleSelectedElements = function toggleSelectedElements(_ref6) {
    var ids = _ref6.ids,
        transactionId = _ref6.transactionId;
    return function (dispatch, getState) {
        var state = getState();
        var currentSelection = (0, _selectedElementsSelector.getSelectedElementIds)(state);

        var selectedIds = ids;
        if (currentSelection.size) {
            var currentlySelectedIds = currentSelection.toJS();

            // Any ID which was selected and is in the ids array that's been toggled should be deselected
            var deselectedIds = (0, _lodash.intersection)(ids, currentlySelectedIds);
            dispatch(removeSelectedElements({ ids: deselectedIds, transactionId: transactionId }));

            selectedIds = (0, _lodash.difference)(ids, currentlySelectedIds);
        }

        return dispatch(addSelectedElements({ ids: selectedIds, transactionId: transactionId }));
    };
};

var deselectAllElements = exports.deselectAllElements = function deselectAllElements() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        var transactionId = args.transactionId;

        var state = getState();

        var currentSelection = (0, _selectedElementsSelector.getSelectedElementIds)(state);
        if (currentSelection.size) {
            dispatch({
                type: SELECTION_ACTION_TYPES.ELEMENTS_DESELECT_ALL,
                ids: currentSelection.toJS(),
                sync: true,
                timestamp: (0, _timeUtil.getTimestamp)(),
                transactionId: transactionId
            });
        }

        if ((0, _currentlyEditingSelector.getCurrentlyEditingId)(state)) {
            dispatch(finishEditingElement());
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/selection/selectionActions.js
// module id = 55
// module chunks = 0